import React, { useEffect, useState } from "react";

import "./contactSupport.scss";
import parse from "html-react-parser";
import { close } from "../../assets/images/icons";

import {
  isMobile,
  navigateToURL,
} from "../../bridges/BridgeServices";
import Chatbot from "../Chatbot/Chatbot";
import PropTypes from "prop-types";
import ChatBotMeta from "../../utils/singletonChatBotMeta";
import { openBot } from "../Chatbot/ChatbotUtil";

const ContactSupport = ({ faqTitle = "" }) => {
  const [shouldOpenChatbot, setOpenChatbot] = useState(
    false
  );
  useEffect(() => {
    const data = {
      ...(faqTitle && {
        faqTitle,
      }),
      src: "FAQ",
    };
    ChatBotMeta.set(data);
  }, []);

  return (
    <>
      <div
        className="support-close-icon hide"
        onClick={() => {
          setOpenChatbot(false);
          document
            .getElementById("mobile-chat-container")
            ?.click();

          if (
            document?.getElementsByClassName(
              "support-close-icon"
            )?.[0]
          ) {
            document.getElementsByClassName(
              "support-close-icon"
            )[0].style.display = "none";
            document
              .getElementsByClassName(
                "support-close-icon"
              )[0]
              .classList.add("hide");
          }
        }}
      >
        {parse(close)}
      </div>
      <div className="contact-support-wrapper">
        <p className="contact-support-text">
          Need more help?
        </p>
        <div
          className="contact-support"
          onClick={() => {
            if (isMobile()) {
              navigateToURL("CHATBOT");
            } else {
              if (
                shouldOpenChatbot ||
                document.getElementsByClassName(
                  "loading-bot"
                )?.[0]
              ) {
                return;
              }
              setOpenChatbot(true);
              openBot();
            }
          }}
        >
          <div
            className={`contact-support-content ${
              !isMobile() ? "loading-bot" : ""
            }`}
          >
            CONTACT SUPPORT
          </div>
        </div>
        <Chatbot shouldOpenChatbot={shouldOpenChatbot} />
      </div>
    </>
  );
};

export default ContactSupport;

ContactSupport.propTypes = {
  faqTitle: PropTypes.string,
};
